import { extend } from './extend';
export var CallRole;
(function (CallRole) {
    CallRole[CallRole["Unknown"] = 0] = "Unknown";
    CallRole[CallRole["Scheduler"] = 1] = "Scheduler";
    CallRole[CallRole["Respondent"] = 2] = "Respondent";
    CallRole[CallRole["Attendee"] = 3] = "Attendee";
    CallRole[CallRole["PrimaryRespondent"] = 4] = "PrimaryRespondent";
    CallRole[CallRole["ModeratorAttendee"] = 5] = "ModeratorAttendee";
})(CallRole || (CallRole = {}));
export const CallRole_Utils = extend(new Map([
    [CallRole.Scheduler, { name: `Moderator` }],
    [CallRole.Respondent, { name: `Respondent` }],
    [CallRole.Attendee, { name: `Attendee` }],
    [CallRole.PrimaryRespondent, { name: `Respondent` }],
    [CallRole.ModeratorAttendee, { name: `Moderator` }],
    [CallRole.Unknown, { name: `Unknown` }],
]));
export var CallChargeOverrideType;
(function (CallChargeOverrideType) {
    CallChargeOverrideType["Custom"] = "custom-rate";
    CallChargeOverrideType["Group"] = "group-rate";
    CallChargeOverrideType["Project"] = "project-rate";
    CallChargeOverrideType["ProjectLink"] = "project-link-rate";
})(CallChargeOverrideType || (CallChargeOverrideType = {}));
export var CallPayoutOverrideType;
(function (CallPayoutOverrideType) {
    CallPayoutOverrideType["Custom"] = "custom-rate";
    CallPayoutOverrideType["Project"] = "project-rate";
    CallPayoutOverrideType["ProjectLink"] = "project-link-rate";
})(CallPayoutOverrideType || (CallPayoutOverrideType = {}));
export var CallStatus;
(function (CallStatus) {
    CallStatus[CallStatus["Scheduled"] = 1] = "Scheduled";
    CallStatus[CallStatus["Completed"] = 2] = "Completed";
    CallStatus[CallStatus["Rejected"] = 3] = "Rejected";
    CallStatus[CallStatus["Pending"] = 4] = "Pending";
    CallStatus[CallStatus["Rescheduling"] = 5] = "Rescheduling";
    CallStatus[CallStatus["Cancelled"] = 6] = "Cancelled";
    CallStatus[CallStatus["MissedByClient"] = 7] = "MissedByClient";
})(CallStatus || (CallStatus = {}));
const statusMap = new Map([
    [CallStatus.Scheduled, { name: 'Scheduled' }],
    [CallStatus.Completed, { name: 'Completed' }],
    [CallStatus.Rejected, { name: 'Rejected' }],
    [CallStatus.Pending, { name: 'Pending' }],
    [CallStatus.Rescheduling, { name: 'Rescheduling' }],
    [CallStatus.Cancelled, { name: 'Cancelled' }],
    [CallStatus.MissedByClient, { name: 'Missed' }],
]);
export var CallType;
(function (CallType) {
    CallType[CallType["Project"] = 1] = "Project";
    CallType[CallType["AdHoc"] = 2] = "AdHoc";
})(CallType || (CallType = {}));
const type = new Map([
    [CallType.Project, { name: 'Project' }],
    [CallType.AdHoc, { name: 'Ad Hoc' }],
]);
export var CallTranscriptionStatus;
(function (CallTranscriptionStatus) {
    CallTranscriptionStatus[CallTranscriptionStatus["InProgress"] = 1] = "InProgress";
    CallTranscriptionStatus[CallTranscriptionStatus["Completed"] = 2] = "Completed";
    CallTranscriptionStatus[CallTranscriptionStatus["Failed"] = 3] = "Failed";
})(CallTranscriptionStatus || (CallTranscriptionStatus = {}));
export default {
    CallRole: CallRole_Utils,
    CallStatus: extend(statusMap),
    CallType: extend(type),
};
